import { BREAKPOINTS, COLORS } from '@laerdal/life-react-components';
import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import posthog from 'posthog-js';

const SubTopics = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 56px;
  width: 100%;
  background: transparent;

  ${BREAKPOINTS.MEDIUM}{
    grid-template-columns: 1fr 1fr;
  }

  ${BREAKPOINTS.LARGE}{
    grid-template-columns: 1fr 1fr 1fr;
  }
`;

const Subtopic = styled.a`
  &:link, &:visited {
    color: ${COLORS.primary_600};
    text-decoration: none; 
  }

  &:hover, &:active {
    color: ${COLORS.primary_600};
    text-decoration: underline; 
  }

  display: flex;
  padding: 24px 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  flex: 1 0 0;
  height: 110px;
  border-radius: 8px;
  border: 1px solid #CCC;
  background: #FFF;

  div {
    color: black;
  }

  p {
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 25px; 
    margin: 0;
    padding: 0;
    max-width: 150px;
  }
`;

interface SubtopicsProps {
  items: FaqItem[]
}
interface FaqItem {
  icon: ReactNode;
  text: string;
  link: string;
}

const Subtopics = ({items}: SubtopicsProps) => {
    const navigate = useNavigate()
      
    return (
        <SubTopics>
          { items.map((item, index) =>
              <Subtopic 
                onClick={(e)=>{
                  e.preventDefault();
                  posthog?.capture('SUPP-Subtopics-CardClick', {
                    component: 'Subtopics',
                    text: item.text,
                    link: item.link
                  });
                  if(item.link!.startsWith('http'))
                    window.location.href = item.link!;
                  else
                    navigate(item.link!);
                }}
                href={item.link} 
                key={`link-${index}`}>
                <div>{item.icon}</div>
                <p>{item.text}</p>
              </Subtopic>
            )
          }
        </SubTopics>
    );
}

export default Subtopics;